import { combineReducers } from 'redux';
import { adminLoginReducer } from './adminReducer';
import { loadingReducer } from './Loading';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  admin: adminLoginReducer,
  loading: loadingReducer
});

export default reducer;
